// extracted by mini-css-extract-plugin
export default {"Payment__Section":"Payment_Payment__Section__Oa4Xq","Payment__Item":"Payment_Payment__Item__eJfAF","Title":"Payment_Title__vMDd9","Icon":"Payment_Icon__1uniB"};